import { createContext, useContext } from 'react';

import RootStore from '../stores/RootStore';

export const storesContext = createContext({
    rootStore: RootStore
});

export const useStores = () => useContext(storesContext);
